import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, SubmitInput, Error, Success, Input } from './styles';
import { useAdminFunction } from '../../hooks/useAdminFunction';
import { AWSStatusIndicator } from '../../components';

// JsonTable component
interface JsonTableProps {
  data: { [key: string]: any };
}

const JsonTable: React.FC<JsonTableProps> = ({ data }) => {
  // Convert the object to an array of objects with key and value properties
  const dataArray = Object.entries(data).map(([key, value]) => ({
    key,
    value: value
  }));

  return (
    <div style={{ overflowY: 'auto', height: '300px' }}>
      <table style={{ width: '100%', border: '1px solid black', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th style={{ border: '1px solid black', textAlign: 'left', padding: '8px' }}>Key</th>
            <th style={{ border: '1px solid black', textAlign: 'left', padding: '8px' }}>Value</th>
          </tr>
        </thead>
        <tbody>
          {dataArray.map((item, index) => (
            <tr key={index}>
              <td style={{ border: '1px solid black', padding: '8px' }}>{item.key}</td>
              <td style={{ border: '1px solid black', padding: '8px' }}>
                {typeof item.value === 'object'
                  ? JSON.stringify(item.value)
                  : item.value.toString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// MobileConfigViewer component
const MobileConfigViewer: React.FC = () => {
  const navigate = useNavigate();
  const { callFunction, isAuthenticated } = useAdminFunction();
  const [error, setError] = useState<string>('');
  const [success, setSuccess] = useState<string>('');
  const [jsonData, setJsonData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleFetchMobileConfig = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    setJsonData(null);
    setError('');
    setSuccess('');
    
    if (!isAuthenticated) {
      navigate('/admin/login');
      return;
    }

    const target = e.target as typeof e.target & {
      version: { value: string };
    };

    const version = target.version.value;

    if (!version) {
      alert('Please enter a version');
      return;
    }

    setIsLoading(true);

    try {
      // Backend determines environment based on authenticated session
      const result = await callFunction('fetchMobileConfig', {
        version
      });
      
      console.log('Mobile config result:', result);
      setJsonData(result);
    } catch (error: any) {
      console.error('Failed to fetch mobile config:', error);
      setError(error?.message || error?.error || 'Failed to fetch mobile config');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AWSStatusIndicator />
      <Form onSubmit={handleFetchMobileConfig}>
        <Input placeholder="Version" name="version" />
        <SubmitInput type="submit" value={isLoading ? "Loading..." : "Fetch MobileConfig"} disabled={isLoading || !isAuthenticated} />
        {error.length > 0 && <Error>{error}</Error>}
        {success.length > 0 && <Success>{success}</Success>}
        {jsonData != null && <JsonTable data={jsonData} />}
      </Form>
    </>
  );
};

export { MobileConfigViewer };
